"use client";

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "next-intl";
import { useState } from "react";
import { useConsent } from "@/components/consent/ConsentProvider";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Switch } from "@/components/ui/switch";
import type { ConsentChoice } from "@/lib/consent/signals";
export function ConsentPreferences() {
  const $ = _c(22);
  const t = useTranslations("consent");
  const {
    preferencesOpen,
    setPreferencesOpen,
    choice,
    defaultChoice
  } = useConsent();
  let t0;
  if ($[0] !== t) {
    t0 = t("preferencesTitle");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <DialogTitle>{t0}</DialogTitle>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("preferencesDescription");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <DialogDescription>{t2}</DialogDescription>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t3) {
    t4 = <DialogHeader>{t1}{t3}</DialogHeader>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== choice || $[12] !== defaultChoice || $[13] !== preferencesOpen) {
    t5 = preferencesOpen && <PreferencesForm initial={choice ?? defaultChoice} />;
    $[11] = choice;
    $[12] = defaultChoice;
    $[13] = preferencesOpen;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t4 || $[16] !== t5) {
    t6 = <DialogContent className="sm:max-w-md">{t4}{t5}</DialogContent>;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== preferencesOpen || $[19] !== setPreferencesOpen || $[20] !== t6) {
    t7 = <Dialog open={preferencesOpen} onOpenChange={setPreferencesOpen}>{t6}</Dialog>;
    $[18] = preferencesOpen;
    $[19] = setPreferencesOpen;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
}
function PreferencesForm(t0) {
  const $ = _c(55);
  const {
    initial
  } = t0;
  const t = useTranslations("consent");
  const {
    save,
    acceptAll,
    rejectAll
  } = useConsent();
  const [analytics, setAnalytics] = useState(initial.analytics);
  const [marketing, setMarketing] = useState(initial.marketing);
  let t1;
  if ($[0] !== t) {
    t1 = t("necessaryTitle");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("necessaryDescription");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <CategoryRow id="consent-necessary" title={t1} description={t2} checked={true} disabled={true} />;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("analyticsTitle");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("analyticsDescription");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== analytics || $[12] !== t4 || $[13] !== t5) {
    t6 = <CategoryRow id="consent-analytics" title={t4} description={t5} checked={analytics} onCheckedChange={setAnalytics} />;
    $[11] = analytics;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t) {
    t7 = t("marketingTitle");
    $[15] = t;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t) {
    t8 = t("marketingDescription");
    $[17] = t;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== marketing || $[20] !== t7 || $[21] !== t8) {
    t9 = <CategoryRow id="consent-marketing" title={t7} description={t8} checked={marketing} onCheckedChange={setMarketing} />;
    $[19] = marketing;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t3 || $[24] !== t6 || $[25] !== t9) {
    t10 = <div className="divide-y">{t3}{t6}{t9}</div>;
    $[23] = t3;
    $[24] = t6;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t) {
    t11 = t("rejectAll");
    $[27] = t;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== rejectAll || $[30] !== t11) {
    t12 = <Button variant="outline" onClick={rejectAll}>{t11}</Button>;
    $[29] = rejectAll;
    $[30] = t11;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== t) {
    t13 = t("acceptAll");
    $[32] = t;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== acceptAll || $[35] !== t13) {
    t14 = <Button variant="outline" onClick={acceptAll}>{t13}</Button>;
    $[34] = acceptAll;
    $[35] = t13;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] !== t12 || $[38] !== t14) {
    t15 = <div className="grid grid-cols-2 gap-2">{t12}{t14}</div>;
    $[37] = t12;
    $[38] = t14;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] !== analytics || $[41] !== marketing || $[42] !== save) {
    t16 = () => save({
      analytics,
      marketing
    });
    $[40] = analytics;
    $[41] = marketing;
    $[42] = save;
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  let t17;
  if ($[44] !== t) {
    t17 = t("saveChoices");
    $[44] = t;
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  let t18;
  if ($[46] !== t16 || $[47] !== t17) {
    t18 = <Button onClick={t16}>{t17}</Button>;
    $[46] = t16;
    $[47] = t17;
    $[48] = t18;
  } else {
    t18 = $[48];
  }
  let t19;
  if ($[49] !== t15 || $[50] !== t18) {
    t19 = <DialogFooter className="gap-2 sm:justify-between">{t15}{t18}</DialogFooter>;
    $[49] = t15;
    $[50] = t18;
    $[51] = t19;
  } else {
    t19 = $[51];
  }
  let t20;
  if ($[52] !== t10 || $[53] !== t19) {
    t20 = <>{t10}{t19}</>;
    $[52] = t10;
    $[53] = t19;
    $[54] = t20;
  } else {
    t20 = $[54];
  }
  return t20;
}
function CategoryRow(t0) {
  const $ = _c(18);
  const {
    id,
    title,
    description,
    checked,
    disabled,
    onCheckedChange
  } = t0;
  let t1;
  if ($[0] !== id || $[1] !== title) {
    t1 = <label htmlFor={id} className="font-medium text-foreground">{title}</label>;
    $[0] = id;
    $[1] = title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = `${id}-description`;
  let t3;
  if ($[3] !== description || $[4] !== t2) {
    t3 = <p id={t2} className="text-muted-foreground">{description}</p>;
    $[3] = description;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t3) {
    t4 = <div>{t1}{t3}</div>;
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = `${id}-description`;
  let t6;
  if ($[9] !== checked || $[10] !== disabled || $[11] !== id || $[12] !== onCheckedChange || $[13] !== t5) {
    t6 = <Switch id={id} aria-describedby={t5} checked={checked} disabled={disabled} onCheckedChange={onCheckedChange} />;
    $[9] = checked;
    $[10] = disabled;
    $[11] = id;
    $[12] = onCheckedChange;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t4 || $[16] !== t6) {
    t7 = <div className="flex items-start justify-between gap-4 py-3">{t4}{t6}</div>;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}